import React, { useState} from "react";
import { Card } from "antd";
import { Gift,
  Award,
  Trophy,
  Rocket,
  Star,
  Sparkles, 
  Zap
} from "lucide-react";
import HeaderComponent from "components/card/HeaderComponent";



const MilestoneSummary = (props) => {
  const {
  } = props;

  const milestoneRewards = [
    {
    id: 1,
    milestone: "Birthday Gift",
    icon: Gift,
    description: "Automatic points awarded on employee birthdays",
    points: 10,
  },
  {
    id: 2,
    milestone: "Work Anniversary",
    icon: Award,
    description:
      "20 points per year of service (e.g., 3 years = 60 points)",
    points: 20,
  },
  {
    id: 3,
    milestone: "5 Year Milestone",
    icon: Trophy,
    description: "Special bonus for reaching 5 years of service",
    points: 500,
  },
  {
    id: 4,
    milestone: "10 Year Milestone",
    icon: Rocket,
    description: "Special bonus for reaching 10 years of service",
    points: 1000,
  },
  {
    id: 5,
    milestone: "Values Award Winner",
    icon: Star,
    description: "Awarded to the winning nominee of values awards",
    points: 50,
  },
  {
    id: 6,
    milestone: "Values Award Nominee",
    icon: Sparkles,
    description:
      "Awarded to employees nominated for values awards",
    points: 25,
  },
  ];

  const getSlug = (milestone) => {
  switch(milestone) {
    case "5 Year Milestone": return "five-year-milestone";
    case "10 Year Milestone": return "ten-year-milestone";
    default: 
      return milestone.toLowerCase()
                      .replace(/[^a-z]+/g, "-")
                      .replace(/^-+|-+$/g, "");
  }
}


  return (
      <HeaderComponent
        title="Automatic Milestone Rewards"
        titleClass="text-[16px] font-medium"
        description="Select an award category to nominate a team member"
        descriptionClass="text-sm"
    >
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {milestoneRewards.map((item) => {
        const Icon = item.icon;
          return (
            <Card 
              key={item.id}
              className={`card-theme ${getSlug(item.milestone)}`}
            >
              <div className="space-y-4">
                <div className="flex flex-col items-start gap-3">
                  <div className="inline-flex items-start justify-between w-full">
                    <div className="icon-style p-3 text-white">
                      { <Icon className="h-6 w-6" />}
                    </div>
                    <div>
                      <span className="border status-color font-medium rounded-xl px-1 py-0.5 text-xs">
                        {item.milestone === "Work Anniversary" ? `${item.points} per year pts` : `${item.points} pts`}
                      </span>
                    </div>
                  </div>
                  <h4 className="card-text text-base">{item.milestone}</h4>
                  <p className="text-[13px] text-muted-foreground">{item.description}</p>
                </div>
              </div>
            </Card>
          );
        })}
      </div>
      <div className="text-card-foreground flex flex-col gap-6 rounded-xl border mt-4 border-emerald-200 bg-emerald-50/50">
        <div className="p-5 inline-flex items-center">
          <div class="flex gap-3 text-emerald-600">
            <Zap className="w-5 h-5"/>
          <div>
            <p class="text-[13px] font-medium text-emerald-900">Fully Automated</p>
            <p class="text-[12px] text-emerald-700">
              These milestone rewards are automatically credited to employee accounts. No manual action required from management.
            </p>
          </div>
        </div>
      </div>
    </div>

    </HeaderComponent>

  );
};

export default MilestoneSummary;
